import React from 'react';

interface IProps {
  textValue: string;
  onChange: (
    newValue: string,
    pages: number[],
    isValid: boolean,
    errorMessage: string
  ) => void;
  pageCount: number;
  maxPagesAllowed: number;
  isPowerpoint: boolean;
}

const RadioFormElement = (props: IProps) => {
  const onChange = (event: any) => {
    const text = event.target.value;
    let errorMessage = '';

    let isValid = true;

    const pages = [];

    try {
      const commaSplit = text.split(',');

      commaSplit.map((rangeText) => {
        const trimmedRange = rangeText.trim();
        const rangeSplit = trimmedRange.split('-');

        const startPage = parseInt(rangeSplit[0]);
        let endPage = startPage;

        if (rangeSplit.length === 2 && rangeSplit[1].length > 0) {
          endPage = parseInt(rangeSplit[1]);
        }

        if (
          (rangeSplit.length === 2 &&
            (Number.isNaN(startPage) || Number.isNaN(endPage))) ||
          (rangeSplit.length === 1 &&
            rangeSplit[0].length > 0 &&
            Number.isNaN(startPage))
        ) {
          throw 'Invalid';
        }

        for (var i = startPage; i <= endPage; i++) {
          if (i > 0 && i <= props.pageCount && !pages.includes(i)) {
            pages.push(i);
          }
        }
      });
    } catch {
      isValid = false;
      errorMessage = 'Invalid Range, e.g. 1-3, 5, 9-12';
    }

    isValid = isValid && pages.length > 0;

    if (isValid && pages.length > props.maxPagesAllowed) {
      isValid = false;
      errorMessage = `Cannot select more than ${props.maxPagesAllowed} ${
        props.isPowerpoint ? 'slides' : 'pages'
      }`;
    }

    isValid = isValid && pages.length <= props.maxPagesAllowed;

    props.onChange(event.target.value, pages, isValid, errorMessage);
  };

  return (
    <div className="form-control">
      <label className="label cursor-pointer">
        <span className="label-text text-base-content"></span>
        <input
          className="focus:shadow-outline appearance-none rounded border px-3 py-2 leading-tight text-gray-700 shadow focus:outline-none"
          id="username"
          autoComplete="off"
          type="text"
          placeholder={`e.g. 1, 8-10, 23`}
          value={props.textValue}
          onChange={onChange}
          autoFocus
        />
      </label>
    </div>
  );
};

export default RadioFormElement;
